import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import moment from "moment-jalaali";
import { CoolSelectPlugin } from "vue-cool-select";
import Vuelidate from 'vuelidate';
import Fragment from 'vue-fragment';
import $, { data } from "jquery";
import VueAxios from "vue-axios";
import requestInterceptor from "@/common/requestInterceptor";
import VueCurrencyInput from 'vue-currency-input';
import VueHtmlToPaper from 'vue-html-to-paper';
import VueCountdownTimer from 'vuejs-countdown-timer';
import responseInterceptor from '@/common/responseInterceptor'
import VueCarousel from 'vue-carousel';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import crisp from '@dansmaculotte/vue-crisp-chat';
var Paginate = require('vuejs-paginate')

export default Plugin.install = function (Vue) {

    import("vue-cool-select/dist/themes/bootstrap.css");
    import("@/assets/daterangepicker.css");
    import("font-awesome/css/font-awesome.min.css");

    Vue.component('VueFontawesome', require('vue-fontawesome-icon/VueFontawesome.vue').default);

    Vue.use(VueCurrencyInput)
    Vue.use(VueAxios, requestInterceptor);
    Vue.use(VueAxios, responseInterceptor);
    Vue.use(CoolSelectPlugin);
    Vue.use(Vuelidate);
    Vue.use(Fragment.Plugin);
    Vue.component('paginate', Paginate)
    Vue.use(VueHtmlToPaper);
    Vue.use(VueCountdownTimer);
    Vue.use(VueCarousel);
    Vue.use(Toast, {
        transition: "Vue-Toastification__fade",
        maxToasts: 12,
        newestOnTop: true
    });
    Vue.use(crisp, {
        websiteId: 'bb2ecfed-03ec-4080-937f-baef0a5f2f4a',
        disabled:   true,
        hideOnLoad: true
      });
    Vue.filter('numFormat', numFormat(numeral));

    Vue.filter('rial', val => `${val} ریال`);

    Vue.filter("persianDate", function (value, format = "jYYYY/jMM/jDD HH:mm:ss") {

        if (moment(value).isValid()) {
            return moment(value).format(format);
        }
        return "";
    });

    Vue.directive("show-modal", function (el, binding) {
        require("magnific-popup");
        $(el).magnificPopup(binding.value);
    });

    Vue.directive("datepicker", function (el, binding) {
        require("@/libs/datePicker.js");
        if (typeof binding.value === "undefined") binding.value = {};

        var options = {
            autoApply: binding.value.autoApply || true,
            singleDatePicker: binding.value.singleDatePicker || true,
            opens: binding.value.opens || "center",
            drops: binding.value.drops || "auto",
            autoUpdateInput: binding.value.autoUpdateInput || false,
            minDate: binding.value.minDate,
            maxDate: binding.value.maxDate,
            format: binding.value.format,
            startDate: binding.value.startDate,
            linkedCalendars: binding.value.linkedCalendars || true,
            locale: binding.value.local,
        };



        $(el).persiandaterangepicker(options);
        $(el).on("apply.daterangepicker", function (e, picker) {
            const gDate = picker.startDate.format("YYYY/MM/DD");
            const pDate = picker.startDate.format('jYYYY/jMM/jDD');

            el.textContent = pDate;
            el.value = pDate;

            el.dispatchEvent(new CustomEvent("change", { detail: { GregorianDate: gDate, PersianDate: pDate } }));
            el.dispatchEvent(new CustomEvent("input", { detail: { GregorianDate: gDate, PersianDate: pDate } }));
        });
    });

    Vue.mixin({
        updated: function () {
            window.dispatchEvent(new Event("load"));
        },
    });

    // Vue.config.errorHandler = function (err/*, vm, info*/) {
    //     alert("error: " + err)
    // };

};